export enum AppLocale {
    EN = 'en',
    DE = 'de',
}

export const localeLabelMap = {
    [AppLocale.EN]: 'English',
    [AppLocale.DE]: 'Deutsch',
};

export const DEFAULT_LOCALE = AppLocale.DE;

// DONT FORGET TO UPDATE MIDDLEWARE MATCHER CONFIG IF YOU MODIFY LOCALES
export const locales: AppLocale[] = [AppLocale.EN, AppLocale.DE];
